<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">

      <section class="card card-body pb-10 pt-1">
        <div class="col-12 w-100 mt-5">
          <div class="row">
            <div class="col-lg-12 col-xxl-12">
              <div class="col-lg-11">
                <b-form @submit.stop.prevent="onSubmit" id="register">
                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h3>{{ $t("PAGE.MANGROVE.FORM.FIELDS.DATA") }} </h3>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">

                    <b-col sm="2">
                      <label>
                        <h5>{{ $t("PAGE.MANGROVE.FORM.FIELDS.NAME") }} : </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="name-input" name="name-input" type="text" v-model="$v.form.name.$model"
                        :state="validateState('name')" aria-describedby="name-live-feedback"></b-form-input>

                      <b-form-invalid-feedback id="name-live-feedback">
                        <span v-if="!$v.form.name.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>

                    </b-col>
                  </b-row>

                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h5>{{ $t("PAGE.MANGROVE.FORM.FIELDS.DETAIL") }} : </h5>
                      </label>
                    </b-col>
                    <b-col sm="10" class="h-50">
                      <b-form-input id="detail-input" name="detail-input" type="text" v-model="$v.form.detail.$model">
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1">
                    <b-col sm="2">
                      <label>
                        <h3>{{ $t("PAGE.MANGROVE.FORM.FIELDS.LOCATION") }} </h3>
                      </label>
                    </b-col>
                  </b-row>

                  <b-row class="mb-5">
                    <b-col sm="12">

                      <GmapMap :center="gmap.center" :zoom="8.5" class="location-map">
                        <GmapMarker :key="index" v-for="(m, index) in gmap.markers" :position="m.position"
                          :clickable="true" :draggable="false" :icon="{ url: 'media/logos/iconmarker.png' }"
                          @click="openWindow($event, index)" />
                        <GmapInfoWindow @closeclick="gmap.window_open = false" :opened="gmap.window_open"
                          :position="gmap.infowindow" :options="{
                            pixelOffset: {
                              width: 0,
                              height: -35,
                            },
                          }">
                          <div class="group-info text-center">
                            <div class="group-name pt-2">
                              <a v-if="gmap.info_url" :href="gmap.info_url" target="_blank">{{ gmap.info_marker }}</a>
                              <span v-else>{{ gmap.info_marker }}</span>
                            </div>

                            <div class="group-address">
                              {{ gmap.address }}
                            </div>
                          </div>
                        </GmapInfoWindow>
                      </GmapMap>

                    </b-col>
                  </b-row>

                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h5>{{ $t("PAGE.MANGROVE.FORM.FIELDS.LATITUDE") }} : </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="latitude-input" name="latitude-input" type="text"
                        v-model="$v.form.latitude.$model" :state="validateState('latitude')"
                        aria-describedby="latitude-live-feedback"></b-form-input>

                      <b-form-invalid-feedback id="latitude-live-feedback">
                        <span v-if="!$v.form.latitude.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>

                  <b-row class="mb-5">
                    <b-col sm="2">
                      <label>
                        <h5>{{ $t("PAGE.MANGROVE.FORM.FIELDS.LONGTITUDE") }} : </h5>
                      </label>
                    </b-col>
                    <b-col sm="10">
                      <b-form-input id="longitude-input" name="longitude-input" type="text"
                        v-model="$v.form.longitude.$model" :state="validateState('longitude')"
                        aria-describedby="longitude-live-feedback"></b-form-input>

                      <b-form-invalid-feedback id="longitude-live-feedback">
                        <span v-if="!$v.form.longitude.required" class="error">
                          {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                        </span>
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <b-button type="submit" variant="primary" class="float-right mr-3">{{
                        $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                        }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 || mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
            <a class="collapse_expend" @click="open_iot=!open_iot,setOpenComponent()" v-b-toggle.open-iot>
              <img v-if="open_iot_id == false" class="vector" src="../../../../public/media/logos/Vector.png" alt="">
              <img v-if="open_iot_id == true" class="vector" src="../../../../public/media/logos/Vector1.png" alt="">
            </a>
            <div class="">
              <h2 class="ml-5 mt-4">IOT</h2>
            </div>
          </div>

          <a @click="open_che_iot=!open_che_iot" class="col-2">
            <div>
              <b-icon class="icon_ron" v-if="open_che_iot == false" icon="chevron-down" aria-hidden="true"></b-icon>
              <b-icon class="icon_ron" v-if="open_che_iot == true" icon="chevron-up" aria-hidden="true"></b-icon>
            </div>
          </a>

        </div>
        <div v-if="open_che_iot" class="col-12  w-100 mt-5">
          <iot />
        </div>
      </section>

      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 || mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
            <a class="collapse_expend" @click="open_video = !open_video" v-b-toggle.open-video>
              <img v-if="open_video == false" class="vector" src="../../../../public/media/logos/Vector.png" alt="">
              <img v-if="open_video == true" class="vector" src="../../../../public/media/logos/Vector1.png" alt="">
            </a>
            <div class="">
              <h2 class="ml-5 mt-4"> {{ $t("PAGE.USER.FORM.FIELDS.VIDEOURL") }}</h2>
            </div>
          </div>
          <a @click="open_video_che=!open_video_che" class="col-2">
            <div class="">
              <b-icon class="icon_ron" v-if="open_video_che == false" icon="chevron-down" aria-hidden="true"></b-icon>
              <b-icon class="icon_ron" v-if="open_video_che == true" icon="chevron-up" aria-hidden="true"></b-icon>
            </div>
          </a>
        </div>
        <div v-if="open_video_che" class="col-12  w-100 mt-5">
          <VideoStreaming />
        </div>
      </section>

      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 | mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
            <a class="collapse_expend " @click="open_pin_infomation = !open_pin_infomation"
              v-b-toggle.open-pin-infomation>
              <img v-if="open_pin_infomation == false" class="vector" src="../../../../public/media/logos/Vector.png"
                alt="">
              <img v-if="open_pin_infomation == true" class="vector" src="../../../../public/media/logos/Vector1.png"
                alt="">
            </a>

          <div class="">
            <h2 class="ml-5 mt-4"> {{ $t("PAGE.PIN_INFOMATION.FORM.FIELDS.NAME") }}</h2>
          </div>
        </div>
          <a @click="open_pin_infomation_che=!open_pin_infomation_che" class="col-2">
            <div class="">
              <b-icon class="icon_ron" v-if="open_pin_infomation_che == false" icon="chevron-down" aria-hidden="true">
              </b-icon>
              <b-icon class="icon_ron" v-if="open_pin_infomation_che == true" icon="chevron-up" aria-hidden="true">
              </b-icon>
            </div>
          </a>
        </div>
        <div v-if="open_pin_infomation_che" class="col-12  w-100 mt-5">
          <pin_infomation />
        </div>
      </section>

      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 || mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
          <a class="collapse_expend" @click="open_points_could = !open_points_could"
            v-b-toggle.open-points-could>
            <img v-if="open_points_could == false" class="vector" src="../../../../public/media/logos/Vector.png" alt="">
            <img v-if="open_points_could == true" class="vector" src="../../../../public/media/logos/Vector1.png" alt="">
          </a>
            <div class="">
              <h2 class="ml-5 mt-4"> {{ $t("PAGE.POINTS_COULD.FORM.FIELDS.NAME") }}</h2>
            </div>
          </div>
          <a @click="open_points_could_che=!open_points_could_che" class="col-2">
            <div class="">
              <b-icon class="icon_ron" v-if="open_points_could_che == false" icon="chevron-down" aria-hidden="true"></b-icon>
              <b-icon class="icon_ron" v-if="open_points_could_che == true" icon="chevron-up" aria-hidden="true"></b-icon>
            </div>
          </a>
        </div>
        <div v-if="open_points_could_che" class="col-12  w-100 mt-5">
          <points_could />
        </div>
      </section>

      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 || mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
          <a class="collapse_expend" @click="open_more_detail_info = !open_more_detail_info"
            v-b-toggle.open-more-detail-info>
            <img v-if="open_more_detail_info == false" class="vector" src="../../../../public/media/logos/Vector.png" alt="">
            <img v-if="open_more_detail_info == true" class="vector" src="../../../../public/media/logos/Vector1.png" alt="">
          </a>
            <div class="">
              <h2 class="ml-5 mt-4"> {{ $t("PAGE.MORE_DERAIL_INFO.FORM.FIELDS.NAME") }}</h2>
            </div>
          </div>
          <a @click="open_more_detail_info_che=!open_more_detail_info_che" class="col-2">
            <div class="">
              <b-icon class="icon_ron" v-if="open_more_detail_info_che == false" icon="chevron-down" aria-hidden="true">
              </b-icon>
              <b-icon class="icon_ron" v-if="open_more_detail_info_che == true" icon="chevron-up" aria-hidden="true"></b-icon>
            </div>
          </a>
        </div>
        <div v-if="open_more_detail_info_che" class="col-12  w-100 mt-5">
          <more_detail_info />
        </div>
      </section>

      <section class="card card-body pb-10 pt-1 mt-5" v-if="id > 0 || mangrove_location_id > 0">
        <div class="row w-100 mt-2 d-flex align-items-center">
          <div class="d-flex col-10 w-100">
          <a class="collapse_expend d-flex align-items-center" @click="open_gallery = !open_gallery"
            v-b-toggle.open-gallery>
            <img v-if="open_gallery == false" class="vector" src="../../../../public/media/logos/Vector.png" alt="">
            <img v-if="open_gallery == true" class="vector" src="../../../../public/media/logos/Vector1.png" alt="">
          </a>
            <div class="">
              <h2 class="ml-5 mt-4"> {{ $t("PAGE.GALLERY.FORM.FIELDS.NAME") }}</h2>
            </div>
          </div>
          <a @click="open_gallery_che=!open_gallery_che" class="col-2">
            <div class="">
              <b-icon class="icon_ron" v-if="open_gallery_che== false" icon="chevron-down" aria-hidden="true"></b-icon>
              <b-icon class="icon_ron" v-if="open_gallery_che == true" icon="chevron-up" aria-hidden="true"></b-icon>
            </div>
          </a>
        </div>
        <div v-if="open_gallery_che" class="col-12  w-100 mt-5">
          <gallery />
        </div>
      </section>
    </div>
    <b-col sm="12" class="mt-5">
      <b-button class="float-right" @click.prevent="cancel()">{{
        $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
        }}</b-button>
      <b-button v-if="id > 0 || mangrove_location_id > 0" @click.prevent="onSubmitStatus" variant="primary"
        class="float-right mr-3">{{
        $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
        }}</b-button>
    </b-col>
  </div>
</template>
<style>
  .vector{
    margin-top: 10px;
    width: 28px;
  height: 28px;
  margin-left: 15px;
  }
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}

.location-map {
  width: 100%;
  height: 400px;
  border-radius: 4px;
  border: 1px solid #fff;
}
.icon_ron{
  margin-top: 15px;
  width: 25px;
  height: 25px;
  margin-left: 80%;
  cursor: pointer;
}
.icon {
  margin-top: 10px;
  width: 25px;
  height: 25px;
  margin-left: 40px;
}

.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import Swal from "sweetalert2";
import pin_infomation from "@/components/pin_infomation/pinInfomationForm";
import more_detail_info from "@/components/more_detail_info/MoreDetailInfoForm";
import iot from "@/components/iot/iot";
import VideoStreaming from "@/components/video_streaming/video_streaming";
import points_could from "@/components/points_could/PointsCouldTable";
import gallery from "@/components/gallery/galleryForm";
import { required } from "vuelidate/lib/validators";
import {
  POST_MANGROVE_LOCATION_DATA,
  GET_MANGROVE_LOCATION_DATA,
  PUT_MANGROVE_LOCATION_DATA,
  SET_STATE_PRAM_M_LOCATION,
  SET_IS_CLEAR_PAGINATION
} from "@/core/services/store/mangrove_location.module";
import { mapState } from "vuex";
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCb-Cr081cGsWBbI8agi4iNQPJK0qcnCI8',
    libraries: 'places',
  },
})

export default {
  mixins: [validationMixin],
  components: {
    iot,
    VideoStreaming,
    pin_infomation,
    more_detail_info,
    points_could,
    gallery
  },

  data() {
    return {
      id: 0,
      status_password: true,
      status_data:null,
      open_pin_infomation_che:false,
      open_points_could_che:false,
      open_che_iot:false,
      open_gallery_che:false,
      open_video_che:false,
      open_more_detail_info_che:false,
      open_iot_id:false,
      form: {
        name: "",
        detail: "",
        latitude: "",
        longitude: ""
      },
      gmap: {
        center: { lat: Number(12.91174796844493), lng: Number(100.38790445504358) },
        markers: [],
        info_marker: null,
        infowindow: { lat: Number(12.91174796844493), lng: Number(100.38790445504358) },
        window_open: false,
        info_url: null,
        image: '',
        address: '',
      },

      mangrove_location_id: 0,
      open_iot: false,
      open_video: false,
      open_pin_infomation: false,
      open_more_detail_info: false,
      open_points_could: false,
      open_gallery: false,
      preview_image: null
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      detail: {
      },
      latitude: {
        required
      },
      longitude: {
        required
      },

    }
  },
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    }),
    nameState() {
      return this.form.name.length > 6 ? true : false
    }
  },
  mounted() {

    this.id = this.$route.params.id;

    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.MANGROVE_INFO.NAME")}`,
        route: "../../user"
      },
      { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
    ]);
    if (this.id > 0) {
      this.setdata(this.id)
      this.get(this.id);
    }
  },
  methods: {
    async setdata(data) {
      await this.$store.commit(SET_STATE_PRAM_M_LOCATION, { mangrove_location_id: data.id });
    },
    setMap(data) {
      this.gmap.markers = []

      this.gmap.markers.push({
        id: data.id,
        position: {
          lat: Number(data.latitude),
          lng: Number(data.longitude),
        },
      })

      this.gmap.center = this.gmap.markers[0].position
      this.gmap.infowindow = this.gmap.markers[0].position
    },

    onSubmit() {
      let formData = new FormData();
      formData.append("name", this.form.name);
      formData.append("detail", this.form.detail);
      formData.append("latitude", this.form.latitude);
      formData.append("longitude", this.form.longitude);

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (this.id > 0) {
        this.update(this.id, formData);
      } else {
        this.create(formData);
      }
    },
    onSubmitStatus() {
      let formData = new FormData();
      if (this.open_iot_id==true) {
        formData.append("iot_status", 1);
      }
      if (this.open_iot_id==false) {
        formData.append("iot_status", 0);
      }
     if (this.open_video==true) {
        formData.append("video_streaming_status", 1);
      }
      if (this.open_video==false) {
        formData.append("video_streaming_status", 0);
      }
      if (this.open_pin_infomation==true) {
        formData.append("pin_infomation_status", 1);
      }
      if (this.open_pin_infomation==false) {
        formData.append("pin_infomation_status", 0);
      }
      if (this.open_points_could==true) {
        formData.append("points_could_status", 1);
      }
      if (this.open_points_could==false) {
        formData.append("points_could_status", 0);
      }
      if (this.open_more_detail_info==true) {
        formData.append("more_detail_info_status", 1);
      }
      if (this.open_more_detail_info==false) {
        formData.append("more_detail_info_status", 0);
      }
      if (this.open_gallery==true) {
        formData.append("gallery_status", 1);
      }
      if (this.open_gallery==false) {
        formData.append("gallery_status", 0);
      }
      formData.append("name", this.form.name);
      formData.append("detail", this.form.detail);
      formData.append("latitude", this.form.latitude);
      formData.append("longitude", this.form.longitude);

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if (this.id > 0) {
        this.updateWithStatus(this.id, formData);
      } else {
        this.createWithStatus(formData);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
   setOpenComponent() {
      this.open_iot_id=!this.open_iot_id
    },
    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_MANGROVE_LOCATION_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                 this.get(data.data.id)
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_MANGROVE_LOCATION_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.get(data.data.id)
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });

              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    createWithStatus(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_MANGROVE_LOCATION_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$router.push("../../mangrove_info");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    updateWithStatus(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_MANGROVE_LOCATION_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE.SUCCESS_TO_SAVE_DATA")}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$router.push("../../mangrove_info");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },

    get(id) {
          this.$store
            .dispatch(GET_MANGROVE_LOCATION_DATA, { id })
            .then(({ data }) => {
              if (data.status === "success" && data.data) {
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
                if (data.data.detail==null) {
                  this.form.detail=""
                }
              this.status_data= data.data;
                 if (data.data.iot_status==1) {
                  this.open_iot_id=  true
                }
                if (data.data.video_streaming_status==1) {
                 this.open_video=true
                }
                if (data.data.pin_infomation_status==1) {
                 this.open_pin_infomation=true
                }
                if (data.data.points_could_status==1) {
                 this.open_points_could=true
                }
                if (data.data.more_detail_info_status==1) {
                 this.open_more_detail_info=true
                }
                if (data.data.gallery_status==1) {
                 this.open_gallery=true
                }
                this.setMap(data.data)
                this.setdata(data.data)
                this.id = data.data.id
                setTimeout(() => {
                  this.$v.$reset();
                }, 50);
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push("../../mangrove_info");
    }
  }
};
</script>
